module.exports = __webpack_public_path__ + "media/images/patent/z_9-bf6b5ac386434360cb74441211378c62.png";